import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import KanbanLogic from './KanbanLogic.js';
import TaskRow from "../task/TaskRow";

class KanbanCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedTask: undefined,
        };

        this.kanbanLogic = new KanbanLogic();

        this.selectTask = this.selectTask.bind(this);
        this.updateTask = this.updateTask.bind(this);
        this.removeTask = this.removeTask.bind(this);
    }

    render() {
        const selection = this.props.selection || {};
        const element = this.props.element;
        const selectedRequirement = (selection != null && element != null && selection.type === element.type && selection.id === element.id);
        const selected = (selectedRequirement && !this.state.selectedTask);
        const showTasks = true;
        const tasks = element.tasks;
        console.log("KanbanCard", element);
        const style = {
            textDecoration: "None",
        };
        if(selected) {
            style.backgroundColor = '#CCC';
            style.border = '2px solid black';
        } else {
            style.backgroundColor = '#EEE';
            style.border = '2px solid gray';
        }

        const listStyle = {
            listItemStyle: "none",
            marginLeft: "0px",
            paddingLeft: "0px"
        };

        return (
            <Card
                onClick={() => {
                    this.props.onSelect(element);
                }}
            >
                <CardContent style={style}>
                    {/*
                    <Typography align={"right"}>
                        {element.requirementType}
                    </Typography>
                    */}
                    <Typography variant="h7">
                        {element.name}
                    </Typography>
                    {
                        showTasks ?
                        <ul style={listStyle}>
                            {
                                Object.keys(tasks).map((i) =>
                                    <TaskRow
                                        key={i}
                                        globals={this.props.globals}
                                        element={tasks[i]}
                                        selected={selectedRequirement && this.state.selectedTask === tasks[i]}
                                        onSelect={this.selectTask}
                                        update={this.updateTask}
                                        remove={this.removeTask}
                                    />
                                )
                            }
                        </ul> :
                        null
                    }
                </CardContent>
            </Card>
        );
    }

    selectTask(task) {
        console.log("KanbanCard.selectTask", task);
        const newSelection = this.state.selectedTask === task ? undefined : task;
        this.setState({
            selectedTask: newSelection,
        })
    }

    updateTask(element, values) {
        console.log("KanbanCard.updateTask", element, values);

        return this.props.globals.updateElement(element, values)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("Result", result);
                    Object.assign(element, result);
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    removeTask(element) {
        console.log("KanbanCard.removeTask", element);

        this.props.globals.deleteElement(element)
            .then(
                (result) => {
                    console.log("Result", result);
                    // TODO Let the parent (board) handle this. The card may have to be removed.
                    //      But this is a drastic thing to do. It changes the plan.
                    // this.getTasks();
                },
                (error) => {
                    console.error(error);
                }
            )
    }
}

export default KanbanCard;
